import { render, staticRenderFns } from "./AudioWidget.vue?vue&type=template&id=1f298a60&scoped=true"
import script from "./AudioWidget.vue?vue&type=script&lang=js"
export * from "./AudioWidget.vue?vue&type=script&lang=js"
import style0 from "./AudioWidget.vue?vue&type=style&index=0&id=1f298a60&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f298a60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f298a60')) {
      api.createRecord('1f298a60', component.options)
    } else {
      api.reload('1f298a60', component.options)
    }
    module.hot.accept("./AudioWidget.vue?vue&type=template&id=1f298a60&scoped=true", function () {
      api.rerender('1f298a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/designer/widgets/AudioWidget.vue"
export default component.exports